import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from '../store';

import es from './es.json';
import pt from './pt.json';
import init from './init.json';

Vue.use(VueI18n);

const languages = {
    init: init,
    es: es,
    pt: pt
}

const i18n = new VueI18n({
    locale: 'es',
    fallbackLocale: 'init',
    messages: languages,
    silentTranslationWarn: true
});

store.dispatch('loadMarket').then(() => {
    const locale = store.getters.getMarket.toLowerCase() || 'es';
    i18n.locale = locale;
})

export default i18n;